import React, { FC } from "react";
import { MediumHeader } from "@narvar/nth-bit-header";
import { ReturnReasonsEditProps } from "./types";
import { useLanguage } from "@narvar/nth-kit-returns-headless";
import { Language } from "../../ReviewSummary/components";
import SelectList from "../../ReviewSummary/components/SelectList/SelectList";

const ReturnReasonsEdit: FC<ReturnReasonsEditProps> = ({ onChange }) => {
  const { rawValue: removeLabel = "" } = useLanguage({
    langKey: "returnsReasonsEditRemoveLabel",
    asString: true,
  });
  const { rawValue: continueLabel = "" } = useLanguage({
    langKey: "returnsReasonsEditContinueLabel",
    asString: true,
  });

  return (
    <>
      <MediumHeader>
        <Language langKey="returnsReasonsEditTitle" />
      </MediumHeader>
      <SelectList
        onChange={onChange}
        options={[
          { value: "remove", label: removeLabel },
          { value: "continue", label: continueLabel },
        ]}
      />
    </>
  );
};

export default ReturnReasonsEdit;
